import { styled, Typography } from '@material-ui/core';
import pathToRegexp from 'path-to-regexp';
import { createElement, FC, MouseEventHandler, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { itemBackground } from '../../../constant/color';
import { SPACING_UNIT } from '../../../constant/spacing';

type Props = {
  icon: ReactNode;
  onClick: MouseEventHandler<HTMLElement>;
  path: string;
  dataIntercomTarget: string;
  messageId: string;
};

const SideBarInternalLinkMenuButton: FC<Props> = ({ icon, onClick, path, messageId, dataIntercomTarget }) => {
  return (
    <ButtonContainer
      style={pathToRegexp(path).test(location.pathname) ? { background: itemBackground } : {}}
      onClick={onClick}
      data-intercom-target={dataIntercomTarget}
    >
      {icon}
      <Label variant={'caption'}>
        <FormattedMessage id={messageId} />
      </Label>
    </ButtonContainer>
  );
};

const ButtonContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  cursor: 'pointer',
  width: '100%',
  padding: `${SPACING_UNIT * 1.5}px ${SPACING_UNIT}px`,
  '&:hover': {
    background: itemBackground,
    transition: 'background 0.3s ease',
  },
});

const Label = styled(Typography)({
  color: '#4C566C',
  fontWeight: 500,
  fontSize: '0.8em',
  marginTop: '2px',
  marginBottom: SPACING_UNIT,
  whiteSpace: 'nowrap',
});

export default SideBarInternalLinkMenuButton;
